'use client';

import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import { BatchLinkPlugin } from '@orpc/client/plugins';
import type { RouterClient } from '@orpc/server';
import { createRouterUtils } from '@orpc/tanstack-query';

import type { BackendRouter } from './router';

export const backendOrpcClient: RouterClient<BackendRouter> = createORPCClient(
  new RPCLink({
    url: () => new URL('/api/orpc', globalThis.location.origin).toString(),
    plugins: [
      new BatchLinkPlugin({
        exclude: ({ path }) => isStreamingProcedurePath(path),
        groups: [{ condition: () => true, context: {} }],
      }),
    ],
  })
);

export const backendOrpc = createRouterUtils(backendOrpcClient);

function isStreamingProcedurePath(path: readonly string[]): boolean {
  if (path.length !== 2) return false;

  const [routerName, procedureName] = path;
  return (
    (routerName === 'chats' && procedureName === 'createChatPrompt') ||
    (routerName === 'judge' && procedureName === 'judge') ||
    (routerName === 'liveLecture' && procedureName === 'watch') ||
    (routerName === 'materialRevision' &&
      (procedureName === 'suggestRevisionFromStumbles' || procedureName === 'suggestRevisionByWebSearch'))
  );
}
